import { type Document as ApiDocument, type SpaceType } from '@api/locations';
import type { EntityStatus } from '@core';
import type { IncidentSeverity } from '@models';

export interface Coordinates {
  height: number;
  left: number;
  top: number;
  width: number;
}

export interface SpaceplanViewport {
  height: number;
  left: number;
  top: number;
  width: number;
}

export enum SpaceplanTabType {
  AUDIO = 'audio',
  CONTROL = 'control',
  NETWORK = 'network',
  VIDEO = 'video',
  FLOORPLAN = 'floorplan',
}

export interface AttachmentPosition {
  coordinates: Coordinates & Partial<Record<SpaceplanTabType, Coordinates>>;
}

export interface AttachmentItemModel {
  deviceId?: string;
  deviceName?: string;
  friendlyName: string;
  id: string;
  incidentCountBySeverity: Record<IncidentSeverity, number>;
  severity?: IncidentSeverity;
  status: EntityStatus;
  type?: SpaceType;
  unstructuredDataReference: string;
}

export interface SpaceplanModel {
  attachments: AttachmentItemModel[];
  documentReference: string;
  id: string;
  parentSpaceId: string | null;
}

export type ImageDocument = ApiDocument;

export const isSpaceplanTabType = (documentTab: string): documentTab is SpaceplanTabType =>
  Object.values(SpaceplanTabType).includes(documentTab as SpaceplanTabType);
